import { SendInitPoll } from 'components-machine';

export const sendInitPoll: SendInitPoll = async ({ poll, state }) => {
  const { revision, wave } = poll;
  const queryParams = new URLSearchParams({ poll_id: poll.id });

  if (revision != null) queryParams.append('revision', String(revision));
  if (wave != null) queryParams.append('wave', String(wave));

  const res = await fetch(`${window.APP_POLL_SERVER_REDUCER}/initPoll?${queryParams.toString()}`, {
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(state),
    credentials: 'same-origin',
    method: 'POST',
  });

  return await res.json();
};
